import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule as PrimengButtonModule } from 'primeng/button';

type ButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule, PrimengButtonModule],
})
export class ButtonComponent {
  @Input() label: string;

  @Input() disabled = false;

  @Input() type: ButtonType = 'button';

  @Input() styleClass = '';

  @Input() piIcon = '';

  @Input() iconPos: 'left' | 'right' | 'top' | 'bottom';

  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
